import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgAddressPickup(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "#1D965C", stroke: "white", strokeWidth: 2 }),
        React.createElement("circle", { cx: 12, cy: 12, r: 3, fill: "white" })));
}
export default SvgAddressPickup;
